import { action, makeObservable, observable } from 'mobx';

export type DownloadStatus = 'downloading' | 'completed';

export interface AttachmentDownload {
    attachmentId: number;
    progress: number;
    status: DownloadStatus;
    fileName: string;
}

export class AttachmentsDownloadStore {
    @observable
    private downloads: Map<number, AttachmentDownload> = new Map();

    constructor() {
        makeObservable(this);
    }

    @action
    setDownloadProgress(attachmentId: number, fileName: string, progress: number): void {
        if (progress === 100) {
            // Don't store completed downloads - they auto-cleanup immediately
            // This prevents Map growth since we only store active downloads
            this.downloads.delete(attachmentId);
            return;
        }

        const status: DownloadStatus = 'downloading';
        this.downloads.set(attachmentId, { attachmentId, fileName, progress, status });
    }

    @action
    removeDownload(attachmentId: number): void {
        this.downloads.delete(attachmentId);
    }

    getDownload(attachmentId: number): AttachmentDownload | undefined {
        return this.downloads.get(attachmentId);
    }

    getAllDownloads(): AttachmentDownload[] {
        return Array.from(this.downloads.values());
    }
}
